<!--
 * @Author: 王佳宾
 * @Date: 2022-10-08 14:06:06
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-11-25 13:40:38
 * @Description: 编辑
 * @FilePath: \web\src\components\lib\Modal\modalChild\edit.vue
-->
<template>
  <section class="popup-content edit">
    <section v-for="(item, index) in projectDetailList" :key="item.title" :class="item.className" class="popup-item">
      <section class="popup-index">
        <span>0{{ index + 1 }}</span>
      </section>
      <!-- / 右上角标题 -->

      <h4>{{ item.title }}</h4>
      <!-- / 标题 -->

      <!-- 资源信息 单独处理 -->
      <a-tabs v-if="item.type === 'projectResourceInfoEntityList'" class="edit-tabs">
        <a-tab-pane v-for="source in editDataList[item.type]" :key="source.commodity" :tab="source.commodity">
          <ul>
            <li v-for="i in item.children" :key="i.title">
              <span class="title" :class="i.className">{{ i.title }}：</span>
              <div class="value" :class="i.className">
                <component v-if="i.component" :is="i.component" v-model:value="source[i.type]" v-bind="i.props">
                </component>
              </div>
            </li>
          </ul>
        </a-tab-pane>
      </a-tabs>

      <!-- 生产信息 单独处理 -->
      <section v-else-if="item.type === 'projectProductEntity'" class="product-entity-content">
        <ul>
          <template v-for="i in item.children" :key="i.title">
            <li v-if="!i.parentType">
              <span class="title" :class="i.className">{{ i.title }}：</span>
              <div class="value" :class="i.className">
                <component v-if="i.component" :is="i.component"
                  v-model:value="editDataList['projectProductEntity'][i.type]" v-bind="i.props"></component>
              </div>
            </li>
          </template>
        </ul>

        <a-tabs class="edit-tabs product-entity">
          <a-tab-pane v-for="source in editDataList['projectProductEntity']['productInfoList']" :key="source.commodity"
            :tab="source.commodity">
            <ul>
              <template v-for="i in item.children" :key="i.title">
                <li v-if="i.parentType">
                  <span class="title" :class="i.className">{{ i.title }}：</span>
                  <div class="value" :class="i.className">
                    <component v-if="i.component" :is="i.component" v-model:value="source[i.type]" v-bind="i.props">
                    </component>
                  </div>
                </li>
              </template>
            </ul>
          </a-tab-pane>
        </a-tabs>
      </section>

      <!-- 默认处理 -->
      <ul v-else>
        <li v-for="i in item.children" :key="i.title">
          <span class="title" :class="i.className">{{ i.title }}：</span>
          <div class="value" :class="i.className">
            <section v-if="i.type === 'commoditiesList'" class="commoditiesList">
              <a-button v-for="co in getCommoditiesList" :key="co" class="btn">
                {{ co.value }}
                <CloseOutlined @click="removeCommodities(co.value, item)" title="删除" />
              </a-button>

              <a-dropdown trigger="click">
                <template #overlay>
                  <a-menu style="height: 2rem; overflow: auto" :multiple="true"
                    @click="(pri) => addCommodities(pri, item)">
                    <a-menu-item v-for="mine in minerals" :key="mine.id" :attr="mine">
                      {{ mine.name }}
                    </a-menu-item>
                  </a-menu>
                </template>
                <a-button type="primary" class="btn">
                  新增矿种
                  <PlusOutlined />
                </a-button>
              </a-dropdown>
            </section>
            <!-- / 全部矿种 单独处理  增删-->

            <a-select v-else-if="i.type === 'globalRegion'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择大洲" style="width: 100%" :options="regions" @change="globalRegionChange">
            </a-select>
            <!-- / 项目所在大洲 -->

            <a-select v-else-if="i.type === 'countryName'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择国家/区域" style="width: 100%" :options="countrys">
            </a-select>
            <!-- / 项目所在国家/区域 -->

            <a-select v-else-if="i.type === 'primaryCommodity'" v-model:value="editDataList[item.type][i.type]"
              show-search placeholder="请选择主矿种" style="width: 100%" :options="getCommoditiesList">
            </a-select>
            <!-- / 主矿种 -->

            <a-select v-else-if="i.type === 'claimType'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择矿权类型" style="width: 100%" :options="claimTypes">
            </a-select>
            <!-- / 矿权类型 -->

            <a-select v-else-if="i.type === 'parentDevStage'" v-model:value="editDataList[item.type][i.bindType]"
              show-search placeholder="请选择开发阶段" style="width: 100%" :options="stages">
            </a-select>
            <!-- / 开发阶段 -->

            <a-select v-else-if="i.type === 'propertyLevel'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择项目级别" style="width: 100%" :options="levels">
            </a-select>
            <!-- / 项目级别 -->

            <a-select v-else-if="i.type === 'infoSource'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择项目信息来源" style="width: 100%" :options="source">
            </a-select>
            <!-- / 项目信息来源 -->
            <a-select v-else-if="i.type === 'ownerCountry'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择最大持股方所属国家" style="width: 100%" :options="allCountrys">
            </a-select>
            <!-- / 最大持股方所属国家 -->
            <a-select v-else-if="i.type === 'buyerCountry'" v-model:value="editDataList[item.type][i.type]" show-search
              placeholder="请选择最近买家所在国" style="width: 100%" :options="allCountrys">
            </a-select>
            <!-- / 最近买家所在国 -->

            <component v-else-if="i.component" :is="i.component" v-model:value="editDataList[item.type][i.type]"
              v-bind="i.props" v-on="i.methods || {}"></component>
          </div>
        </li>
      </ul>
      <!-- / 详情 -->
    </section>
  </section>
</template>

<script setup>
import { ref, watch, defineProps, toRefs, computed, defineExpose, } from 'vue';
import {
  getMineralsApi,
  getRegionApi,
  getCountryApi,
  getInfoSourceApi,
  getClaimTypeApi,
  getProjectLevel,
  getProjectStages,
} from '@/api/utils/utilsApi';
import { CloseOutlined, DownOutlined, PlusOutlined, } from '@ant-design/icons-vue';
import { changeMineralList, } from '@/components/utils/utils';

// 定义
const props = defineProps({
  dataList: {
    type: Object,
    default: () => ({}),
  },
  projectDetailList: {
    type: Array,
    default: [],
  },
});
// 定义 component
// 结构props
const { dataList, } = toRefs(props);

// 克隆
const editDataList = ref({});

/**
 * @description 添加矿种
 */
const addCommodities = ({ item, }, parent) => {
  const { attr, } = item;
  const sourceItem = {
    id: null,
    propId: null,
    commodity: attr.name,
    propName: null,
    provedReserves: null,
    provedReservesRank: null,
    containedReserves: null,
    containedReservesRank: null,
    sumReserves: null,
    sumReservesRank: null,
    provedResource: null,
    provedResourceRank: null,
    controlledResource: null,
    controlledResourceRank: null,
    containedResource: null,
    containedResourceRank: null,
    sumResource: null,
    sumResourceRank: null,
    unitMetal: null,
    unitSavour: null,
  };

  const projectItem = {
    id: null,
    propId: null,
    propName: null,
    productionCapacity: null,
    lastYearCapacity: null,
    previousYearCapacity: null,
    totalProductionPerCost: null,
    commodity: attr.name,
    unitMetal: null,
    unitSavour: null,
  };

  const commoditiesValue = editDataList.value[parent.type].commoditiesList;

  let klist;

  if (commoditiesValue) {
    klist = commoditiesValue.split(',').concat(attr.name).join(',');
  } else {
    klist = attr.name;
  }

  editDataList.value[parent.type].commoditiesList = klist;
  editDataList.value.projectResourceInfoEntityList.push(sourceItem);
  editDataList.value['projectProductEntity']['productInfoList'].push(projectItem);
};

/**
 * @description 删除矿种
 * @param {*} name
 */
const removeCommodities = (name, parent) => {
  const klist = editDataList.value[parent.type].commoditiesList.split(',');

  klist.splice(
    klist.findIndex((i) => i === name),
    1
  );

  // 删除矿种
  editDataList.value[parent.type].commoditiesList = klist.join(',');
  // 删除资源信息
  editDataList.value.projectResourceInfoEntityList.splice(
    editDataList.value.projectResourceInfoEntityList.findIndex((i) => i.commodity === name),
    1
  );
  // 删除生产信息
  editDataList.value['projectProductEntity']['productInfoList'].splice(
    editDataList.value['projectProductEntity']['productInfoList'].findIndex((i) => i.commodity === name),
    1
  );
};

/**
 * @description 复制datalist
 */
const setCloneDataList = (val) => {
  editDataList.value = JSON.parse(JSON.stringify(val));
};

// -------------↓ 处理逻辑 可复用
// ref
const regions = ref([]); // 大洲
const countrys = ref([]); // 国家
const allCountrys = ref([]); // 全部管家
const minerals = ref([]); // 矿种
const levels = ref([]); // 项目级别
const source = ref([]); // 来源
const claimTypes = ref([]); // 矿权
const stages = ref([]); // 阶段

// 获取全部矿种
const getCommoditiesList = computed(() => {
  const commoditiesValue = editDataList.value['propInfoEntity']['commoditiesList'];

  if (commoditiesValue) {
    return editDataList.value['propInfoEntity']['commoditiesList']?.split(',').map((i) => ({ value: i, label: i, }));
  }

  return null;
});

/**
 * @description 选择大洲
 */
const globalRegionChange = (value, { id, clear, }) => {
  getCountryApi({ id, }).then((res) => {
    // 请求大洲 清空选中的值
    if (!clear) {
      editDataList.value['projectGeoInfoEntity'].countryName = null;
    }

    if (res.code === 200) {
      countrys.value = res.data.map((item) => ({ ...item, value: item.countryName, label: item.countryName, }));
    }
  });
};

const initRequest = () => {
  getMineralsApi().then((res) => {
    if (res.code === 200) {
      minerals.value = changeMineralList(res.data);
    }
  });

  getRegionApi().then((res) => {
    if (res.code === 200) {
      const globalName = editDataList.value['projectGeoInfoEntity'].globalRegion;

      if (globalName) {
        const { id, } = res.data.find((i) => i.countryName === globalName);

        globalRegionChange(null, { id, clear: true, });
      }
      regions.value = res.data.map((item) => ({ ...item, value: item.countryName, label: item.countryName, }));
    }
  });

  getInfoSourceApi().then((res) => {
    if (res.code === 200) {
      source.value = res.data.map((item) => ({ ...item, value: item.name, label: item.name, }));
    }
  });

  getClaimTypeApi().then((res) => {
    if (res.code === 200) {
      claimTypes.value = res.data.map((item) => ({ ...item, value: item.name, label: item.name, }));
    }
  });

  getCountryApi({ id: '', }).then((res) => {
    if (res.code === 200) {
      allCountrys.value = res.data.map((item) => ({ ...item, value: item.countryName, label: item.countryName, }));
    }
  });

  getProjectLevel().then((res) => {
    levels.value = res;
  });

  getProjectStages().then((res) => {
    stages.value = res;
  });
};

watch(
  dataList,
  (val) => {
    if (val) {
      setCloneDataList(val);
      initRequest();
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

defineExpose({
  editDataList,
});
</script>

<style lang="scss"></style>
